import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="text-lg font-bold" style={{ fontFamily: "var(--font-heading)" }}>
                西瓜影院
              </span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-lg">
              本站是一个关于“西瓜影院在线观看”的帮助信息页面，汇总下载方式、播放器推荐与常见播放问题的解决方法，
              内容均为一般性使用建议，供排查问题时参考。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h2 className="text-sm font-semibold text-background-50 mb-4">页面导航</h2>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-300/70">© 2026 西瓜影院帮助中心 · 内容仅供学习与参考</p>
          <p className="text-xs text-background-300/70">页面内容不涉及任何实际播放或下载服务</p>
        </div>
      </div>
    </footer>
  );
}